import { Pipe, PipeTransform } from '@angular/core';
import { Label } from 'src/app/labels/englishLabels';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Pipe({
  name: 'labelsProvider',
  standalone: true,
})
export class LabelsProviderPipe implements PipeTransform {
  constructor(private readonly _logger: LoggerService) {}

  public transform = (label?: string): string => (label ? (Label.get(label) ?? this._missingLabel(label)) : '');

  private _missingLabel(label: string): string {
    this._logger.error(`Label ${label} is not part of IWebAppLabels`);
    return 'Label Missing';
  }
}
